import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const POSTS = [
  {
    slug: "the-art-of-arrival",
    title: "The Art of Arrival",
    excerpt: "On candles, playlists, and the small rituals that turn an evening into an occasion.",
    category: "Intimacy",
    minutes: 4,
    img: "/products/brand-story-bg.jpg",
  },
  {
    slug: "0045mm-the-science",
    title: "0.045mm: The Science of Sensation",
    excerpt: "How precision-rolling and electronic testing produce the BananaX Signature feel.",
    category: "Atelier",
    minutes: 6,
    img: "/products/ultra-thin-signature.jpg",
  },
  {
    slug: "discretion-as-a-design-principle",
    title: "Discretion as a Design Principle",
    excerpt: "Unmarked couriers, quiet billing, soft paper — why we engineer the packaging first.",
    category: "Brand",
    minutes: 3,
    img: "/products/monthly-box.jpg",
  },
  {
    slug: "five-questions-with-our-dermatologist",
    title: "Five Questions With Our Dermatologist",
    excerpt: "Sensitive skin, allergens, and the gentle decisions behind our formulation.",
    category: "Wellness",
    minutes: 5,
    img: "/products/long-lasting-noir.jpg",
  },
];

export default function Blog() {
  return (
    <div className="pt-32 pb-24 min-h-screen" data-testid="blog-page">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="mb-16">
          <div className="label-eyebrow mb-4">The BananaX Journal</div>
          <h1 className="font-serif text-5xl md:text-7xl tracking-tight leading-none">
            Notes on intimate <span className="italic text-gradient-gold">wellness</span>.
          </h1>
        </div>

        <div className="grid md:grid-cols-2 gap-12">
          {POSTS.map((p, i) => (
            <motion.article
              key={p.slug}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              className="group"
              data-testid={`blog-card-${p.slug}`}
            >
              <div className="product-image-wrap aspect-[16/10] mb-6 border hairline">
                <img src={p.img} alt={p.title} className="w-full h-full object-cover" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-t from-ink-950/80 via-transparent to-transparent"></div>
              </div>
              <div className="label-eyebrow mb-3">{p.category} · {p.minutes} min read</div>
              <h2 className="font-serif text-3xl text-bone leading-tight group-hover:text-gold transition-colors mb-3">
                {p.title}
              </h2>
              <p className="text-mist font-light leading-relaxed mb-4">{p.excerpt}</p>
              <div className="inline-flex items-center gap-2 text-gold text-xs tracking-[0.22em] uppercase">
                Read essay <ArrowRight className="w-3.5 h-3.5" />
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </div>
  );
}
